// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"9f145f7e","117":"9f145f7e","376":"9f145f7e","434":"9f145f7e","717":"9f145f7e","931":"9f145f7e"}[chunkId] + ".chunk.css";
};